export interface TelegramAccount {
  connected: boolean
  username: string
}

export const TELEGRAM_ACCOUNT_LOAD_ERROR =
  'Could not load the Telegram connection.'
